import { Logger } from "../HelperFunctions";
import EncryptedStorage from "react-native-encrypted-storage";
import Constants from "../Constants";

const storeData = async (key: string, value: string) => {
  const jsonValue = JSON.stringify(value);
  try {
    await EncryptedStorage.setItem(key, jsonValue);
  } catch (e) {
    Logger("LocalStore storeData  error =======", e);
  }
};

const storeObjectData = async (key: string, value: string) => {
  try {
    const jsonValue = JSON.stringify(value);
    await EncryptedStorage.setItem(key, jsonValue);
  } catch (e) {
    Logger("LocalStore storeObjectData  error =======");
  }
};

const storeNavigationObjectData = async (selectedPolicyNumber: string) => {
  try {
    const _selectedPolicyNumber = JSON.stringify(selectedPolicyNumber);
    await EncryptedStorage.setItem(
      Constants.LocalStoreConstant.SELECTED_POLICY_NUMBER,
      _selectedPolicyNumber,
    );
  } catch (e) {
    Logger("LocalStore storeNavigationObjectData  error =======");
  }
};

const getData = async (key: string) => {
  try {
    const value = await EncryptedStorage.getItem(key);
    if (value !== null) {
      return JSON.parse(value);
    }
  } catch (e) {
    Logger("LocalStore getData  error =======");
  }
};

const getObjectData = async (key: string) => {
  try {
    const jsonValue = await EncryptedStorage.getItem(key);
    return jsonValue != null ? JSON.parse(jsonValue) : null;
  } catch (e) {
    Logger("LocalStore getObjectData  error =======");
  }
};

const clearData = async (key: string) => {
  try {
    await EncryptedStorage.removeItem(key);
  } catch (e) {
    Logger("LocalStore clearData  error =======" + e);
  }
};

const clearAll = async () => {
  Logger("LocalStore clearAll =======");
  try {
    const appUpdateSkippedValue = await EncryptedStorage.getItem(
      Constants.LocalStoreConstant.APP_UPDATE_SKIPPED,
    );
    await EncryptedStorage.clear();
    if (appUpdateSkippedValue) {
      await EncryptedStorage.setItem(
        Constants.LocalStoreConstant.APP_UPDATE_SKIPPED,
        appUpdateSkippedValue,
      );
    }
  } catch (e) {
    Logger("LocalStore clearAll  error =======");
  }
};

export default {
  storeData,
  storeObjectData,
  storeNavigationObjectData,
  clearData,
  clearAll,
  getObjectData,
  getData,
};
